import { ChartFragment } from 'models/api-response';
import { ChartActionsComponentProps, ChartMetaFormField, PatientContext } from 'models/ui';
import { Locales } from 'constants/app.constant';
import { Box, ChartActions, ChartPermission, ErrorCard, ErrorFormField } from 'components/common';
import { ELSFlex, ELSFlexItem } from 'components/common/els';
import { FormField, SectionTitle } from './ActivityOccupationalTherapy';
import ActivityOccupationalTherapyReadOnly from './ActivityOccupationalTherapyReadOnly';

interface ActivityOccupationalTherapyViewProps {
  isLocked: boolean;
  fragment: ChartFragment;
  statusFragment: ChartFragment;
  resetAll: number;
  chartActionsProps: ChartActionsComponentProps;
  chartMetaFormFields: Map<string, ChartMetaFormField>;
  formSubmittedCount: number;
  patientContext: PatientContext;
}

const ActivityOccupationalTherapyView = (props: ActivityOccupationalTherapyViewProps) => {
  const { isLocked, fragment, formSubmittedCount, chartMetaFormFields, resetAll, statusFragment, patientContext } = props;
  return (
    <div className="activity-occupational-therapy">
      {isLocked ? (
        <ActivityOccupationalTherapyReadOnly chartFragment={fragment} statusFragment={statusFragment} locale={patientContext?.locale} />
      ) : (
        <>
          <h1>Activity - Occupational Therapy Screen</h1>
          <ErrorCard chartMetaFormFields={chartMetaFormFields} showErrorCard={formSubmittedCount > 0} />
          <Box mt2>
            <ELSFlex className="u-flex-gutter-3x" left wrap>
              <ELSFlexItem w="1o2" md="1o1">
                <Box mb>
                  <h2>{SectionTitle.NEW_OCCUPATIONAL_THERAPY}</h2>
                </Box>
                <Box mb>
                  <ErrorFormField formField={chartMetaFormFields.get(FormField.NO_NEW_OCCUPATIONAL)} formSubmittedCount={formSubmittedCount} useDefaultMargin={false} />
                </Box>
                <ErrorFormField key={resetAll} formField={chartMetaFormFields.get(FormField.NEW_OCCUPATIONAL_THERAPY)} formSubmittedCount={formSubmittedCount} />
              </ELSFlexItem>
              <ELSFlexItem w="1o2" md="1o1">
                <Box mb>
                  <h2>{SectionTitle.IMPAIRMENT_ENVIDENCE}</h2>
                </Box>
                <ErrorFormField formField={chartMetaFormFields.get(FormField.IMPAIRMENT_ENVIDENCE)} formSubmittedCount={formSubmittedCount} formFieldMap={chartMetaFormFields} />
              </ELSFlexItem>
            </ELSFlex>
            <ELSFlexItem w="1o2" md="1o1">
              <ErrorFormField
                formField={chartMetaFormFields.get(FormField.OCCUPATIONAL_THERAPY_RESTRICTION)}
                formSubmittedCount={formSubmittedCount}
                options={{ displayHorizontal: true }}
              />
            </ELSFlexItem>
            {patientContext.locale === Locales.EN_AU && (
              <>
                <Box mt2>
                  <ErrorFormField
                    formField={chartMetaFormFields.get(FormField.REQUIRES_OT_ASSESSMENT)}
                    formSubmittedCount={formSubmittedCount}
                    options={{ displayHorizontal: true }}
                  />
                </Box>
                <Box mt2>
                  <ErrorFormField formField={chartMetaFormFields.get(FormField.NOTES)} formSubmittedCount={formSubmittedCount} />
                </Box>
              </>
            )}
          </Box>
          <ChartPermission fragmentType={fragment?.fragmentType}>{({ allowSaveFragment }) => allowSaveFragment && <ChartActions {...props.chartActionsProps} />}</ChartPermission>
        </>
      )}
    </div>
  );
};

ActivityOccupationalTherapyView.displayName = 'ActivityOccupationalTherapyView';
export default ActivityOccupationalTherapyView;
